import { Grid, IconButton, useTheme } from '@mui/material'
import GridOnIcon from '@mui/icons-material/GridOn'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'

export enum LayoutFormat {
  Grid,
  Table,
}

interface ILayoutButtonsProps {
  handleLayoutChange: () => void
  layoutFormat: LayoutFormat
}

const LayoutButtons = ({ handleLayoutChange, layoutFormat }: ILayoutButtonsProps) => {
  const theme = useTheme()

  return (
    <Grid ml="auto" mb={2.5}>
      <IconButton
        onClick={handleLayoutChange}
        disabled={LayoutFormat.Table === layoutFormat}
        sx={{
          ':disabled': {
            color: theme.palette.custom.primary,
          },
          color: theme.palette.custom.grey,
        }}
      >
        <FormatListBulletedIcon />
      </IconButton>
      <IconButton
        onClick={handleLayoutChange}
        disabled={LayoutFormat.Grid === layoutFormat}
        sx={{
          ':disabled': {
            color: theme.palette.custom.primary,
          },
          color: theme.palette.custom.grey,
        }}
      >
        <GridOnIcon />
      </IconButton>
    </Grid>
  )
}

export { LayoutButtons }
